import { render, staticRenderFns } from "./IconLogout.vue?vue&type=template&id=f8b0293a&"
import script from "./IconLogout.vue?vue&type=script&lang=ts&"
export * from "./IconLogout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports